import { render } from "./Header.vue?vue&type=template&id=f1050f84"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=f1050f84&lang=scss"
script.render = render

export default script